
import { useSelector } from 'react-redux';

export default function useAuthIsLogged() {
    const logged = useSelector(state => {
        return (
            state.auth.data  &&
            state.auth.data.user
        );
    });
    return logged;
}
